import React from 'react';
import PropTypes from 'prop-types';

import Header from '../shared/header';
import Footer from '../shared/footer';
import LanguageDirection from '../shared/languageDirection';
import Modal from '../shared/modal';
import MainComment from './mainComment';

class CommentComponent extends React.Component {
  componentDidMount() {
    this.props.displayModal(''); // Clear modal on display to prevent errors

    if (this.props.locale) {
      this.props.getTranslations(this.props.locale, true);
    } else {
      this.props.getTranslations();
    }

    this.props.getUserInfo(this.props.params.accountInfo, this.props.locale);

  }

  render() {
    const {
      modalOnDisplay,
      comment: { logo, program },
      locale,
      commentsInfoReceived,
      displayModal,
      translations,
      uploadedImages,
    } = this.props;

    const shouldModalDisplay =
      modalOnDisplay === 'comment-suggestion' ||
      modalOnDisplay.includes('cropper');

    return (
      <div>
        <LanguageDirection locale={locale}>
          <Header logo={logo} />
          {commentsInfoReceived && <MainComment {...this.props} />}
          {!commentsInfoReceived && <div className="loading" />}
          {shouldModalDisplay && (
            <Modal
              modalOnDisplay={modalOnDisplay}
              displayModal={displayModal}
              translations={translations}
              color={program.color}
              uploadedImages={uploadedImages}
            />
          )}

          <Footer
            translations={this.props.translations}
            updateLocale={this.props.updateLocale}
            privacyPolicyLink={this.props.privacyPolicyLink}
            locale={this.props.locale}
          />
        </LanguageDirection>
      </div>
    );
  }
}

CommentComponent.propTypes = {
  addTempUserComment: PropTypes.func,
  addTempUserName: PropTypes.func,
  bannedWordError: PropTypes.string,
  comment: PropTypes.shape({
    logo: PropTypes.string,
    program: PropTypes.shape({
      color: PropTypes.string
    })
  }).isRequired,
  commentsInfoReceived: PropTypes.bool.isRequired,
  deleteUploadedPhoto: PropTypes.func,
  displayModal: PropTypes.func,
  error: PropTypes.string,
  getTranslations: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  imageLoading: PropTypes.number,
  locale: PropTypes.string,
  modalOnDisplay: PropTypes.string,
  params: PropTypes.shape({
    accountInfo: PropTypes.string,
  }),
  previewToggle: PropTypes.bool,
  privacyPolicyLink: PropTypes.string,
  rotatePhoto: PropTypes.func,
  autoOrientImage: PropTypes.func,
  spinnerDisplay: PropTypes.bool,
  submitComment: PropTypes.func,
  tempComment: PropTypes.shape({}),
  togglePreview: PropTypes.func,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  updateLocale: PropTypes.func,
  uploadImage: PropTypes.func,
  uploadedImages: PropTypes.array,
  validateCommentForm: PropTypes.func,
};

CommentComponent.defaultProps = {
  addTempUserComment: () => {},
  addTempUserName: () => {},
  bannedWordError: '',
  deleteUploadedPhoto: () => {},
  displayModal: () => {},
  error: '',
  imageLoading: 0,
  locale: '',
  modalOnDisplay: '',
  params: {},
  previewToggle: false,
  privacyPolicyLink: '',
  rotatePhoto: () => {},
  autoOrientImage: () => {},
  spinnerDisplay: false,
  submitComment: () => {},
  tempComment: {},
  togglePreview: () => {},
  updateLocale: () => {},
  uploadImage: () => {},
  uploadedImages: [],
  validateCommentForm: () => {},
};

export default CommentComponent;
